import { PaymentProviderId } from '@/types/tickets';

export interface BookingResponse {
    purchaseTransactionId: string;
    bookingTimeInterval: number;
    finalPrice: number;
    platformFee: number;
    currencyCode: string;
    paymentGatewayUrl: string;
    ticketPrice: number;
    ticketsQuantity: number;
}

export interface PurchaseTransaction {
    id: string;
    status: 'paid' | 'payment_declined';
    buyer_id: string;
    final_price: number;
    currency_code: string;
    pre_auth_response_code: string;
    pre_auth_response_msg: string;
    pre_auth_pg_tran_appr_code: string;
    pre_auth_pg_order_id: string;
    pre_auth_pg_tran_id: string;
    post_auth_pg_tran_date: string;
    post_auth_pg_tran_ref_id: string;
    payment_provider: PaymentProviderId;
}

export enum FormSlide {
    ticket = 0,
    submit = 1,
    result = 2,
}

export const paymentQueryParamKeys = [
    'tickets',
    'couponCode',
    'formSlide',
    'payment_provider',
    'customer_address',
    'customer_first_name',
    'customer_second_name',
    'customer_email',
    'customer_telegram',
    'customer_phone',
    'event_id',
] as const;

export type PaymentQueryParams = {
    [K in (typeof paymentQueryParamKeys)[number]]: string | undefined;
};
